import { render, staticRenderFns } from "./ListaItens.vue?vue&type=template&id=896db9e8"
import script from "./ListaItens.vue?vue&type=script&lang=js"
export * from "./ListaItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports